export default __webpack_public_path__ + "static/media/bg-banner-cta-1.7c7b4f57.jpg";